import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import { makeStyles } from '@material-ui/styles'
import EnhancedTable from 'components/tables/enhanced-table'
import { getInitials } from 'lib/text-display'

const useRowStyles = makeStyles(theme => ({
  info: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    minWidth: 0,
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  avatar: {
    height: 36,
    width: 36,
    flexShrink: 0,
    backgroundColor: '#EBF0F2',
    color: '#172024',
    fontSize: '13px',
    fontWeight: 500,
  },
  text: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.15px',
  },
  textSecondary: {
    color: theme.palette.text.secondary,
    fontSize: '12px',
    lineHeight: '16px',
  },
}))

const columns = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    width: '50%',
    mobile: true,
    sortable: false,
  },
  {
    id: 'email',
    label: 'Email',
    align: 'left',
    width: '50%',
    mobile: true,
    sortable: false,
  },
]

const WaitlistListItem = ({ entry }) => {
  const classes = useRowStyles()
  const { firstName, lastName, email } = entry.contact
  const contactName = `${firstName} ${lastName}`

  return (
    <TableRow data-testid={`waitlist-list-row-${entry.contact.id}`}>
      <TableCell className={classes.info}>
        <Box className={classes.nameCell}>
          <Avatar className={classes.avatar}>{getInitials(contactName)}</Avatar>
          <Typography className={classes.text} noWrap>
            {contactName}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={classes.info}>
        <Typography className={classes.textSecondary} noWrap>
          {email}
        </Typography>
      </TableCell>
    </TableRow>
  )
}

WaitlistListItem.propTypes = {
  entry: PropTypes.shape({
    contact: PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }),
  }).isRequired,
}

const Waitlist = ({ contacts }) => {
  const rows = contacts.map(entry => (
    <WaitlistListItem key={entry.contact.id} entry={entry} />
  ))

  return (
    <EnhancedTable
      rows={rows}
      columns={columns}
      label="Waitlist"
      variant="list"
      rowHeight="56px"
      showHeaderPagination={false}
      showPaginator={false}
      emptyState={() => null}
    />
  )
}

Waitlist.propTypes = {
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      contact: PropTypes.shape({
        id: PropTypes.string.isRequired,
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
      }),
    }),
  ),
}

export default Waitlist
